export default __webpack_public_path__ + "static/media/Arrow.4ab54f46.svg";